import axios from '@/api/ai-axios';
import LoadingSpinner from '@/components/loading-spinner';
import { useImmer } from 'use-immer';
import { getUrlParams } from './utils/url-parse';
import { message } from 'antd';
import { useCallback, useEffect } from 'react';
import { setLocalStorageExpire } from './utils/cookie-tool';
import { useDispatch } from 'react-redux';
import { setUID } from '@/reducers/users';
import useAuth from '@/hooks/useAuth';

const expiresTime = 60 * 24 * 30; // cookie过期时间, 单位：分钟

// ST 第三方登录所需参数
const ST_LOGIN_PARAMS = [
  'client_id',
  'sign',
  'mobile',
  'nickname',
  'timestamp',
];

const StLoginHOC = (WrappedComponent) => {
  const StLoginWrapper = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useImmer(true);
    const { checkLogin } = useAuth();

    useEffect(() => {
      stLogin();
    }, []);

    const stLogin = useCallback(async () => {
      try {
        const allParams = getUrlParams();

        // 检查是否包含所有 ST 登录参数
        const hasAllParams = ST_LOGIN_PARAMS.every(
          (key) => allParams && allParams[key],
        );

        if (!hasAllParams) {
          return; // 无 ST 登录参数，走正常流程
        }

        // 收集 ST 登录参数
        const loginParams = {};
        ST_LOGIN_PARAMS.forEach((key) => {
          loginParams[key] = allParams[key];
        });

        try {
          const res = await axios.post('/api/login_st', loginParams);

          if (res.status == 1) {
            // 登录成功
            const uid = res.data.uid;
            setLocalStorageExpire('uid', uid, expiresTime);
            dispatch(setUID(uid));
            await checkLogin();

            // 清理 URL 中的 ST 参数
            const { VITE_ORIGIN } = import.meta.env;
            const { pathname } = window.location;
            const searchParams = new window.URLSearchParams(
              window.location.search,
            );
            ST_LOGIN_PARAMS.forEach((key) => searchParams.delete(key));
            searchParams.delete('redirect');
            searchParams.delete('redirect_to');
            const paramsString = searchParams.toString();
            const newUrl = `${VITE_ORIGIN}${pathname}${
              paramsString ? `?${paramsString}` : ''
            }`;
            window.history.replaceState({}, '', newUrl);
          } else {
            message.error(res.message || res || 'ST 登录校验失败');
          }
        } catch (err) {
          // axios 已处理异常，此处防止未捕获的错误
        }
      } catch (err) {
        message.error(err.message || err);
      } finally {
        setLoading(false);
      }
    }, [checkLogin, dispatch]);

    return loading ? (
      <LoadingSpinner loading={true} />
    ) : (
      <WrappedComponent {...props} />
    );
  };

  return StLoginWrapper;
};

export default StLoginHOC;
